import React, {  useEffect } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import FloatLabel from "../FloatingLabel";

const DateComponent = (props) => {
  const { item, formData, field, form, placeholder, dateFormat, partner } = props;
  const { code } = item;
  const {  value, name } = field;
 

  const { setFieldValue, values, handleBlur, setFieldError } = form;
  let hide = false;

  if (code == "OtherDocExpDate") {
    const dependedField = formData.filter(
      (formItem) => formItem.code == "OtherDocType"
    );
    if (dependedField && dependedField.length > 0) {
      if (values[`${dependedField[0].id}`] == "voterId") {
        hide = true;
      }
    }
  }

  useEffect(() => {
    if (value) {
      const currentDate = moment();
      const selectedDate = moment(value);
      const age = currentDate.diff(selectedDate, "years");
      if (partner?.id === 207 && age < 21) {
        setTimeout(() => {
          setFieldError(name, "Minimum age required is 21");
        });
      } else if (partner?.id === 219 && age < 26) {
        setTimeout(() => {
          setFieldError(name, "Minimum age required is 26");
        })
      }
    }
  }, [partner?.id, value, form]);

 if (!hide) {
    return (
      <FloatLabel label={placeholder} name={name} value={value || null}>
        {value !== undefined && <DatePicker
          size="large"
          className="custom-date-picker"
          placeholder=""
          style={{ width: "100%" }}
          format={dateFormat ? dateFormat : "DD/MM/YYYY"}
          onChange={(date, dateString) => {
            if (date != null) {
              setFieldValue(name, date.format( dateFormat ? dateFormat : "DD/MM/YYYY"));
            } else {
              setFieldValue(name, "");
            }
          }}
          onBlur={handleBlur(name)}
          defaultValue={value? moment(value, dateFormat ? dateFormat : "DD/MM/YYYY") : ""}
          inputReadOnly
        />}
      </FloatLabel>
    );
  }
  return null;
};

export default DateComponent;
